import { useDispatch, useSelector } from 'react-redux'

import {
  removeNotificationAction,
  removeNotificationAfterDelayAction
} from '@/bus/notifications'
import { IRootState } from '@/store/reducer'

export const useNotifications = () => {
  const dispatch = useDispatch()
  const { data = [] } = useSelector(
    ({ notifications }: IRootState) => notifications
  )

  const removeAfterDelay = (props: object) =>
    dispatch(removeNotificationAfterDelayAction(props))

  const remove = (props: object) => dispatch(removeNotificationAction(props))

  return {
    data,
    removeAfterDelay,
    remove
  }
}
